import { matchPath } from "react-router";
import {
  ENTITY_PATH,
  DATA_SOURCES_EDITOR_ID_PATH,
  INTEGRATION_EDITOR_PATH,
  SAAS_GSHEET_EDITOR_ID_PATH,
} from "constants/routes";
import {
  MODULE_EDITOR_PATH,
  UI_PACKAGE_EDITOR_PATH,
  PACKAGE_LIBRARIES_EDITOR_PATH,
} from "ee/constants/routes/packageRoutes";
import { EditorState } from "IDE/enums";

export function getCurrentPackageState(currentUrl: string): EditorState {
  const match = matchPath<{
    entity?: "datasource" | "settings" | "libraries";
    datasourceId?: string;
    selectedTab?: string;
  }>(currentUrl, {
    path: [
      UI_PACKAGE_EDITOR_PATH + DATA_SOURCES_EDITOR_ID_PATH,
      UI_PACKAGE_EDITOR_PATH + SAAS_GSHEET_EDITOR_ID_PATH,
      UI_PACKAGE_EDITOR_PATH + INTEGRATION_EDITOR_PATH,
      UI_PACKAGE_EDITOR_PATH + ENTITY_PATH,
      UI_PACKAGE_EDITOR_PATH + PACKAGE_LIBRARIES_EDITOR_PATH,
      MODULE_EDITOR_PATH + ENTITY_PATH,
    ],
  });

  if (match) {
    const { datasourceId, entity, selectedTab } = match.params;

    if (entity === "datasource" || datasourceId || selectedTab) {
      return EditorState.DATA;
    } else if (entity === "settings") {
      return EditorState.SETTINGS;
    } else if (entity === "libraries") {
      return EditorState.LIBRARIES;
    } else {
      return EditorState.EDITOR;
    }
  }

  return EditorState.EDITOR;
}
